export default __webpack_public_path__ + "static/media/file_00002.6cb3ce32.pdf";